import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { ConsentsAndAuthorizationsDocumentsModal } from './ConsentsAndAuthorizationsDocumentsModal';

type ConsentsAndAuthorizationsDocumentsModalOpenerRenderProps = { openModal: VoidFunction };
type ConsentsAndAuthorizationsDocumentsModalOpenerProps = {
   readonly children: (renderProps: ConsentsAndAuthorizationsDocumentsModalOpenerRenderProps) => ReactElement;
   readonly patientId: number;
};

export const ConsentsAndAuthorizationsDocumentsModalOpener = (
   props: ConsentsAndAuthorizationsDocumentsModalOpenerProps
): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <ConsentsAndAuthorizationsDocumentsModal onClose={closeModal} patientId={props.patientId} />
         ) : null}
      </>
   );
};
